import { useEffect } from 'react'
import type { BoggleStore } from '~/boggle/ui/state/Store'

export function useBoggleClock(
  store: BoggleStore,
  { enabled = true }: { enabled?: boolean } = {},
) {
  useEffect(() => {
    if (!enabled) {
      return
    }

    let frameHandle = 0
    let lastFrameMs = 0

    const tick = (frameMs: number) => {
      const deltaMs =
        lastFrameMs === 0 ? 16 : Math.min(32, Math.max(0, frameMs - lastFrameMs))
      lastFrameMs = frameMs

      if (store.shouldAdvanceClock()) {
        store.advance(deltaMs)
      }

      frameHandle = window.requestAnimationFrame(tick)
    }

    frameHandle = window.requestAnimationFrame(tick)

    return () => {
      window.cancelAnimationFrame(frameHandle)
    }
  }, [enabled, store])
}
